import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "UA-156414581-1" }
}, router);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
